import { render, staticRenderFns } from "./GeneralAddProduct.vue?vue&type=template&id=2ed3f750&"
import script from "./GeneralAddProduct.vue?vue&type=script&lang=js&"
export * from "./GeneralAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports